import React, {useMemo, useState} from "react";
import {withRouter} from "react-router-dom";
import {Collapse, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {
    Business as AccountIcon,
    ExpandLess,
    ExpandMore,
    Fingerprint as PasswordIcon,
    Info as AboutIcon,
    Logout as LogoutIcon,
    People as UsersIcon,
    Settings as SettingsIcon,
    SwapHoriz as SwitchIcon,
} from "@mui/icons-material";
import {AccountAvatar} from "@atttomyx/react-components";
import {authService} from "../../services";
import {confirm, mobile, router} from "@atttomyx/react-utils";
import {sorting} from "@atttomyx/shared-utils";
import {accounts as accountConstants} from "@atttomyx/shared-constants";
import {PAGE_ABOUT, PAGE_ACCOUNT, PAGE_JOIN_ACCOUNT, PAGE_PASSWORD, PAGE_SETTINGS, PAGE_USERS,} from "../../constants";
import "./moreMenu.css";

const MoreMenu = (props) => {
    const {snackbar, history, accounts, account, user, onCancel, onLogout, onSwitchAccounts} = props;
    const [showAccounts, setShowAccounts] = useState(false);

    const disabled = useMemo(() => {
        return account.status === accountConstants.STATUS_DISABLED;
    }, [account]);

    const closeAndRedirect = (page) => {
        onCancel();
        router.redirectTo(history, page);
    };

    const closeAndSwitchAccounts = (accountId) => {
        onCancel();
        authService.switchAccounts(accountId, onSwitchAccounts, snackbar.setError);
    };

    const renderLogo = (account) => {
        const branding = account.branding || {};

        return <>
            <ListItemIcon>
                <AccountAvatar account={account} size="small" mode="no-title"/>
            </ListItemIcon>
            {!branding.logoContainsName ?
                <ListItemText>{account.name}</ListItemText> : null}
        </>
    };

    const renderAccounts = () => {
        return <>
            <ListItemButton onClick={() => setShowAccounts(!showAccounts)}>
                <ListItemIcon><SwitchIcon/></ListItemIcon>
                <ListItemText>Switch</ListItemText>
                {showAccounts ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={showAccounts} timeout="auto" unmountOnExit>
                <List disablePadding className="sub-menu">
                    {accounts.sort(sorting.sortByName).filter(candidate => candidate.id !== account.id).map(account =>
                        <ListItemButton
                            key={account.id}
                            onClick={() => closeAndSwitchAccounts(account.id)}
                        >
                            {renderLogo(account)}
                        </ListItemButton>)}
                    <ListItemButton onClick={() => closeAndRedirect(PAGE_JOIN_ACCOUNT)}>
                        <ListItemText>Join account...</ListItemText>
                    </ListItemButton>
                </List>
            </Collapse>
        </>
    };

    return <Drawer
        anchor="right"
        className="more-menu"
        open={true}
        onClose={onCancel}
    >
        <List>
            {user.roles.admin ? <>
                    <ListItemButton disabled={disabled} onClick={() => closeAndRedirect(PAGE_ACCOUNT)}>
                        <ListItemIcon><AccountIcon/></ListItemIcon>
                        <ListItemText>Account</ListItemText>
                    </ListItemButton>
                    <ListItemButton disabled={disabled} onClick={() => closeAndRedirect(PAGE_USERS)}>
                        <ListItemIcon><UsersIcon/></ListItemIcon>
                        <ListItemText>Users</ListItemText>
                    </ListItemButton>
                    <Divider/>
                </> : null}
            <ListItemButton disabled={disabled} onClick={() => closeAndRedirect(PAGE_SETTINGS)}>
                <ListItemIcon><SettingsIcon/></ListItemIcon>
                <ListItemText>Settings</ListItemText>
            </ListItemButton>
            <ListItemButton disabled={disabled} onClick={() => closeAndRedirect(PAGE_PASSWORD)}>
                <ListItemIcon><PasswordIcon/></ListItemIcon>
                <ListItemText>Password</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => confirm.confirm(mobile.isMobile()
                ? "Someone would need to have physical access to your phone to access this account. Are you sure you want to logout?"
                : "Are you sure you want to logout?", onLogout)}>
                <ListItemIcon><LogoutIcon/></ListItemIcon>
                <ListItemText>Logout</ListItemText>
            </ListItemButton>
            {renderAccounts()}
            <Divider/>
            <ListItemButton disabled={disabled} onClick={() => closeAndRedirect(PAGE_ABOUT)}>
                <ListItemIcon><AboutIcon/></ListItemIcon>
                <ListItemText>About</ListItemText>
            </ListItemButton>
        </List>
    </Drawer>
};

export default withRouter(MoreMenu);
